// extracted by mini-css-extract-plugin
export default {"stores":"aO4fK8","stores-title":"_0lnd9"};